import { render, staticRenderFns } from "./editSIGoods.vue?vue&type=template&id=9caa888a&scoped=true&"
import script from "./editSIGoods.vue?vue&type=script&lang=js&"
export * from "./editSIGoods.vue?vue&type=script&lang=js&"
import style0 from "./editSIGoods.vue?vue&type=style&index=0&id=9caa888a&lang=less&scoped=true&"
import style1 from "./editSIGoods.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9caa888a",
  null
  
)

component.options.__file = "editSIGoods.vue"
export default component.exports